module.exports = __webpack_public_path__ + "static/img/page3.d948744.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/page3.jpg
// module id = 4p2V
// module chunks = 1